import { createContext, useContext } from 'react';

export const createCtx = (initial) => {
	const ctx = createContext(initial);

	const useCtx = () => {
		const context = useContext(ctx);

		if (context === undefined) {
			throw new Error('useCtx must be inside a Provider with a value');
		}

		return context;
	};

	return [useCtx, ctx.Provider];
};
